// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDI2gLBwIBFoWoLQIhTb4i02apqePwnmY0",
  authDomain: "supporty-staging.firebaseapp.com",
  projectId: "supporty-staging",
  storageBucket: "supporty-staging.firebasestorage.app",
  messagingSenderId: "1093393296196",
  appId: "1:1093393296196:web:e46047edc1778f4e69c511",
};
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const messaging = getMessaging(app);
